<script lang="ts">
  import { createBubbler } from 'svelte/legacy';

  const bubble = createBubbler();
  import { twMerge } from 'tailwind-merge';

  interface Props {
    type?: 'button' | 'submit' | 'reset';
    variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
    size?: 'small' | 'medium' | 'large';
    disabled?: boolean;
    loading?: boolean;
    fullWidth?: boolean;
    clas?: string;
    children?: import('svelte').Snippet;
  }

  let {
    type = 'button',
    variant = 'primary',
    size = 'medium',
    disabled = false,
    loading = false,
    fullWidth = false,
    clas = '',
    children
  }: Props = $props();

  const baseStyles = 'font-medium rounded focus:outline-none focus:ring-0 focus:ring-offset-0 transition-colors';

  const variantStyles = {
    primary: 'text-white bg-primary-green hover:bg-primary-buttonHover rounded-full transform transition-transform duration-100 active:bg-primary-buttonActive active:scale-95 outline-none ring-0',
    secondary: 'bg-primary-secondaryButton hover:bg-primary-secondaryButtonHover active:bg-primary-secondaryButtonActive rounded-full py-1.5 px-6 font-medium text-sm text-white transform transition-transform duration-100 active:scale-95 outline-none ring-0',
    outline: 'bg-transparent border border-primary-green text-primary-green hover:bg-primary-darkNavy/10 focus:ring-primary-green',
    ghost: 'bg-transparent text-primary-green hover:bg-primary-darkNavy/10 focus:ring-primary-green'
  };

  const sizeStyles = {
    small: 'px-1 py-0.5 md:px-2 md:py-1 text-sm md:text-sm',
    medium: 'px-3 py-1.5 md:px-6 md:py-2 text-sm md:text-base',
    large: 'px-3 py-1.5 md:px-6 md:py-3 text-base md:text-lg'
  };


  let buttonClasses = $derived(twMerge(
    baseStyles,
    variantStyles[variant],
    sizeStyles[size],
    fullWidth && 'w-full',
    disabled && 'opacity-50 cursor-not-allowed',
    loading && 'relative text-transparent',
    clas
  ));
</script>

<button
  {type}
  class={buttonClasses}
  onclick={bubble('click')}
  {disabled}
  aria-disabled={disabled || loading}
>
  {#if loading}
    <span class="absolute inset-0 flex items-center justify-center">
      <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    </span>
  {/if}
  <span class={loading ? 'invisible' : ''}>
    {@render children?.()}
  </span>
</button>
